var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.89688 0.896875 1 2 1H14C15.1031 1 16 1.89688 16 3V13C16 14.1031 15.1031 15 14 15H2C0.896875 15 0 14.1031 0 13V3ZM10.1187 6.32812C9.97812 6.12187 9.74687 6 9.5 6C9.25313 6 9.01875 6.12187 8.88125 6.32812L6.1625 10.3156L5.33437 9.28125C5.19062 9.10312 4.975 9 4.75 9C4.525 9 4.30625 9.10312 4.16563 9.28125L2.16563 11.7812C1.98438 12.0063 1.95 12.3156 2.075 12.575C2.2 12.8344 2.4625 13 2.75 13H5.75H6.75H13.25C13.5281 13 13.7844 12.8469 13.9125 12.6C14.0406 12.3531 14.025 12.0562 13.8687 11.8281L10.1187 6.32812ZM3.5 6C4.32812 6 5 5.32812 5 4.5C5 3.67188 4.32812 3 3.5 3C2.67188 3 2 3.67188 2 4.5C2 5.32812 2.67188 6 3.5 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a951d80d08631ef554ade8ec06e8c5b5.svg";
export { ForwardRef as ReactComponent };